import { useMutation, useQueryClient } from "@tanstack/react-query";

import { integrationService } from "../../../services/integrationService";

export const useDeleteIntegration = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async ({ integrationId }: { integrationId: string }) => {
      const deleted = await integrationService.delete(integrationId);
      return { deleted, integrationId };
    },
    onSuccess: ({ integrationId }) => {
      qc.invalidateQueries({ queryKey: ["integration", integrationId] });
      qc.invalidateQueries({ queryKey: ["integrations"] });
    },
  });
};
